var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"scroll-wrp"},[_c('div',{staticClass:"content-sections"},[_c('div',{staticClass:"page-spinner"},[_c('div',{staticClass:"logo-spinner-t1"})])])])}]

export { render, staticRenderFns }